import { computed, type Ref } from 'vue'
import scssVariables from '@/assets/scss/scssVariables'

import {
  STATUS_TRAVEL_AND_HOTEL,
  type StatusTravelAndHotel,
} from '@/constants/persoplan'
import { type Nilable } from '@/types/misc'

export { type StatusTravelAndHotel, STATUS_TRAVEL_AND_HOTEL }

interface Options {
  status: Ref<Nilable<StatusTravelAndHotel>>
}

const colors = {
  needed: scssVariables.color['status-travelAndHotel-needed'],
  requested: scssVariables.color['status-travelAndHotel-requested'],
  confirmed: scssVariables.color['status-travelAndHotel-confirmed'],
  communicated: scssVariables.color['status-travelAndHotel-communicated'],
} as const satisfies Record<StatusTravelAndHotel, string>

export function useTravelAndHotelStatus(options: Options) {
  const classes = computed(() => {
    if (!options.status.value) return

    return {
      [`is-statusTravelAndHotel-${options.status.value}`]: true,
    }
  })

  const color = computed(() => {
    if (!options.status.value) return

    return colors[options.status.value]
  })

  return {
    classes,
    color,
  }
}
